import Http from 'lib/http';
import { IProductData, IFeedbackSiteData, IFeedbackReportError } from './types';

const sendNotFoundProduct = ({ productName, barcode, email, shopID }: IProductData): Promise<{}> => {
  return Http.post('feedback/product', {
    name: productName,
    code: barcode,
    email,
    shop_id: shopID,
  });
};

const sendFeedbackSite = ({ rating, comment, email }: IFeedbackSiteData): Promise<{}> => {
  return Http.post('feedback/desktop', {
    points: rating,
    comment,
    email,
  });
};

const sendErrorReport = ({ shopId, modelId, productId, text, errors }: IFeedbackReportError): Promise<{}> => {
  return Http.post('feedback/error', {
    shop_id: shopId,
    model_id: modelId,
    product_id: productId,
    error_types: errors,
    text,
  });
};

export default {
  sendNotFoundProduct,
  sendFeedbackSite,
  sendErrorReport,
};
